import roles from "@/roles";
export default [
  {
    icon: "report_problem",
    title: "Deliverability Alerts",
    roles: [roles.ADMIN, roles.BETA_FEATURE],
    children: [
      {
        icon: "map",
        router: true,
        title: "Alerts Map",
        to: "DeliverabilityAlertsMap",
        roles: [roles.ADMIN, roles.BETA_FEATURE]
      }
    ]
  }
];
